export default {
      ProductModels: 'الموديل|الموديلات',
      ProductModels_no_body: 'موديل',

};
